module.exports = __webpack_public_path__ + "static/Mimic-e6f37f086803a758abe5509c6e1eda7b.jpg";